// Tutorial data for Ellipsometry (Tutorial 2)
// This dynamically loads the actual .txt/.dat files using file processing functions

import tutorialDataFile from './TutorialData_Bulk_Reflection.txt';
import detectorFile2 from './TutorialData_Bulk_Reflection_Detector2.dat';
import detectorFile3 from './TutorialData_Bulk_Reflection_Detector3.dat';

// Function to create a File object from the imported text file
export const createTutorialFile = async (step = 1) => {
  try {
    // Choose file based on tutorial step
    if (step >= 19) {
      // For step 19+, return both detector files
      const files = await Promise.all([
        createSingleFile(detectorFile2, "STO-Detector2_Tutorial.dat"),
        createSingleFile(detectorFile3, "STO-Detector3_Tutorial.dat")
      ]);
      return files;
    } else {
      // For earlier steps, use the main reflectivity file
      return await createSingleFile(tutorialDataFile, "STO-Reflectivity_Tutorial.txt");
    }
  } catch (error) {
    console.error('Error loading tutorial data file:', error);
    throw error;
  }
};

// Helper function to create a single file
const createSingleFile = async (fileUrl, fileName) => {
  const response = await fetch(fileUrl);
  const content = await response.text();
  
  return new File(
    [content],
    fileName,
    {
      type: fileUrl.endsWith('.dat') ? 'application/octet-stream' : 'text/plain',
      lastModified: Date.now()
    }
  );
};

export default {
  createTutorialFile
};
